import { Component, ElementRef, Input, OnDestroy, OnInit, viewChild, output } from '@angular/core';
import * as echarts from 'echarts';

@Component({
  selector: 'app-echart',
  templateUrl: './echart.component.html',
  styleUrl: './echart.component.scss',
  standalone: false,
})
export class EchartComponent implements OnInit, OnDestroy {
  readonly containerRef = viewChild<ElementRef<HTMLDivElement>>('container');

  @Input() options!: echarts.EChartsOption;
  @Input() theme?: string;
  @Input() loading = false;

  readonly chartClick = output<{ name: string; seriesName: string; value: any }>();

  private instance?: echarts.ECharts;

  ngOnInit(): void {
    this.initChart();
  }

  ngOnDestroy(): void {
    this.instance?.dispose();
  }

  private initChart(): void {
    const el = this.containerRef()?.nativeElement;
    if (!el) return;
    this.instance?.dispose();
    this.instance = echarts.init(el, this.theme);
    this.instance.setOption(this.options);
    this.instance.on('click', (params: any) => {
      this.chartClick.emit({ name: params.name, seriesName: params.seriesName, value: params.value });
    });
  }

  resize(): void {
    this.instance?.resize();
  }
}
